// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import {
    MY_ORDER_LIST_VIEW_CLASS_NAME
} from "../../../../../core/constants/className";

import {
    T_DATE_TIME_FORMAT,
    T_MY_ORDER_LIST_VIEW_NO_RESULTS_FOUND,
    T_MY_ORDER_LIST_VIEW_TABLE_ORDER_ID_LABEL,
    T_MY_ORDER_LIST_VIEW_TABLE_STATUS_LABEL,
    T_MY_ORDER_LIST_VIEW_TABLE_TIME_LABEL,
    T_MY_ORDER_LIST_VIEW_TITLE
} from "../../../../../core/constants/translation";
import { useParams } from "react-router-dom";
import { useMyOrderList } from "../../../../hooks/useMyOrderList";
import { Table } from "../../../../../../../io/hyperify/frontend/components/table/Table";
import { TableHeader } from "../../../../../../../io/hyperify/frontend/components/table/TableHeader";
import { TableHeaderColumn } from "../../../../../../../io/hyperify/frontend/components/table/TableHeaderColumn";
import { TableBody } from "../../../../../../../io/hyperify/frontend/components/table/TableBody";
import { TableRow } from "../../../../../../../io/hyperify/frontend/components/table/TableRow";
import { map } from "../../../../../../../io/hyperify/core/functions/map";
import { OrderDTO } from "../../../../../../../io/hyperify/core/store/types/order/OrderDTO";
import { TimeColumn } from "../../../../../../../io/hyperify/frontend/components/table/columns/time/TimeColumn";
import { TextColumn } from "../../../../../../../io/hyperify/frontend/components/table/columns/text/TextColumn";
import "./MyOrderListView.scss";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";

export interface MyOrderListViewProps {
    readonly className ?: string;
    readonly t?: TranslationFunction;
}

export function MyOrderListView (props: MyOrderListViewProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const params = useParams();
    const clientId = params?.clientId;
    const [list/*, refreshList*/] = useMyOrderList(clientId);
    return (
        <div className={
            MY_ORDER_LIST_VIEW_CLASS_NAME
            + (className? ` ${className}` : '')
        }>
            <h3>{t(T_MY_ORDER_LIST_VIEW_TITLE)}</h3>
            <div className={`${MY_ORDER_LIST_VIEW_CLASS_NAME}-details`}>{!list ? (
                <p>{t(T_MY_ORDER_LIST_VIEW_NO_RESULTS_FOUND)}</p>
            ) : (

                    <Table>
                        <TableHeader>
                            <TableHeaderColumn>{t(T_MY_ORDER_LIST_VIEW_TABLE_ORDER_ID_LABEL)}</TableHeaderColumn>
                            <TableHeaderColumn>{t(T_MY_ORDER_LIST_VIEW_TABLE_TIME_LABEL)}</TableHeaderColumn>
                            <TableHeaderColumn>{t(T_MY_ORDER_LIST_VIEW_TABLE_STATUS_LABEL)}</TableHeaderColumn>
                        </TableHeader>
                        <TableBody>{map(
                            list,
                            (item: OrderDTO) => {
                                return (
                                    <TableRow>
                                        <TextColumn value={item?.orderId} />
                                        <TimeColumn value={item?.date} format={t(T_DATE_TIME_FORMAT)} />
                                        <TextColumn value={item?.status} />
                                    </TableRow>
                                );
                            }
                        )}
                        </TableBody>
                    </Table>
            )}</div>
        </div>
    );
}
